import { useEffect, useRef } from "react";

/**
 * Auto-scroll hook that scrolls to bottom when dependencies change
 */
export function useAutoScroll(
  containerRef,
  dependencies = [],
  options = {}
) {
  const {
    enabled = true,
    threshold = 30,
    behavior = "smooth",
    delay = 0,
  } = options;

  const shouldScrollRef = useRef(true);
  const lastScrollTopRef = useRef(0);

  useEffect(() => {
    if (!enabled || !containerRef.current) {
      return;
    }

    const container = containerRef.current;

    const checkScrollPosition = () => {
      const distanceFromBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      shouldScrollRef.current = distanceFromBottom < threshold;
    };

    const handleScroll = () => {
      checkScrollPosition();
    };

    container.addEventListener("scroll", handleScroll, { passive: true });
    checkScrollPosition();

    const scrollToBottom = () => {
      if (shouldScrollRef.current && container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior,
        });
      }
    };

    const timeoutId = setTimeout(scrollToBottom, delay);

    return () => {
      container.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutId);
    };
  }, [containerRef, enabled, threshold, behavior, delay, ...dependencies]);
}


